export const SITE = {
  name: 'DashLink Gaming',
  operator: 'DashLink Gaming',
  email: 'nishansengupta@gmail.com',
  domain: 'dashlinkgaming.com',
  legalUpdated: 'November 3, 2026',
  defaultTitle: 'DashLink Gaming — Play, Chat & Squad Up With Gamers Worldwide',
  defaultDescription:
    'DashLink Gaming is a free social gaming hub: play Tic-Tac-Toe and Checkers online in real time, chat with emojis and voice dictation, find a squad, host watch parties and climb the leaderboard.',
  keywords:
    'online games, multiplayer tic tac toe, play checkers online, gaming chat, find gaming squad, gaming community, game leaderboard, watch party, LFG',
};

export const pageTitle = (title) => (title ? `${title} | ${SITE.name}` : SITE.defaultTitle);
